module.exports = __webpack_public_path__ + "img/category-favorite.fdae9a44.png";